import type { FC, ReactNode } from 'react'

import SegmentLogo from '@segment/matcha/components/SegmentLogo'
import Typography from '@segment/matcha/components/Typography'
import ButtonText from '@segment/matcha/components/ButtonText'

import * as Navbar from '@segment/matcha/recipes/Navigation2/DesktopNavigation/Navbar'
import DesktopNavBase, * as DesktopNav from '@segment/matcha/recipes/Navigation2/DesktopNavigation'
import type { UtilityNavProps } from '@segment/matcha/recipes/Navigation2/types'

import { usePageConfig } from '@segment/contexts/page'

interface NavigationDesktopProps extends UtilityNavProps {
  after?: ReactNode
  buttonText: string
  buttonLink: string
}

const NavigationDesktop: FC<NavigationDesktopProps> = ({ announcement, buttonText, buttonLink, after }) => {
  const { appUrl } = usePageConfig()

  return (
    <DesktopNavBase>
      {announcement && <DesktopNav.UtilityNav announcement={announcement} />}

      <DesktopNav.Navbar>
        <Navbar.Brand href="/">
          <SegmentLogo alt="Twilio, Inc." />
        </Navbar.Brand>
        <Navbar.Aside>
          <Typography tag="span" variant="pSmall">
            Already have an account?
          </Typography>
          <ButtonText size="small" tag="a" href={`${appUrl}${buttonLink}`} variant="mono">
            {buttonText}
          </ButtonText>
        </Navbar.Aside>
      </DesktopNav.Navbar>
      {after}
    </DesktopNavBase>
  )
}

export default NavigationDesktop
